import React from 'react';
import { IconButton } from '@mui/material';
import { useTranslate } from 'react-admin';
import ClosePopupIcon from '@/assets/icons/close-popup-icon.svg?react';

const CustomCloseButton = ({ onClose }) => {
    const translate = useTranslate();

    return (
        <IconButton onClick={onClose} type='button' className='close-popup' aria-label={translate('common.close')}>
            <ClosePopupIcon />
        </IconButton>
    );
};

export default CustomCloseButton;
